import { plugin as analytics } from '@mc-alberta/analytics'
import * as i18nData from '@mc-alberta/i18n-data'
import { mapActions } from 'vuex'
import CONSTANTS from '@/constants'
import logKpiResult from '@/utils/logKpiResult'

/**
 * @fileoverview wrapper plugin for alberta's analytics plugin
 */

// Ensure page load analytics are only logged once
let shouldExecuteAnalytics = true

export default {
  install: (Vue, options) => {
    Vue.use(analytics, options)

    Vue.prototype.$EVENTS = CONSTANTS.ANALYTICS.EVENTS

    Vue.mixin({
      beforeRouteEnter(to, from, next) {
        next((vm) => {
          let payload = vm.$EVENTS.PAGE_LOAD
          let kpiPayload = {}

          if (to.meta.analyticsPageLoad) {
            payload = to.meta.analyticsPageLoad(vm)
          }
          // Setting the ui metadata when routing to error page
          if (to.name === CONSTANTS.ROUTES.ERROR && !!to.params?.analyticsFeature) {
            payload = {
              event: vm.$EVENTS.PAGE_LOAD,
              meta: { authenticationResult: CONSTANTS.ANALYTICS.ERROR }
            }
          }

          if (shouldExecuteAnalytics) {
            if (to.meta.kpiPageLoad) {
              kpiPayload = {
                ...to.meta.kpiPageLoad(),
                correlationId: vm.$store.state.correlationid
              }
              logKpiResult(kpiPayload)
            }
            vm.$analytics.track(payload)
            shouldExecuteAnalytics = false
          }
        })
      },
      beforeRouteLeave(to, from, next) {
        shouldExecuteAnalytics = true
        next()
      },

      methods: {
        ...mapActions(['resetAnalyticsState']),
        /**
         * Send locale-related analytics data to adobe
         * and then reset the relevant state variables in between analytics submissions
         *
         * @param {String} event - adobe event to associate with
         */
        trackLocaleChanges(event) {
          const { isLocaleSelectorSelected, user } = this.$store.state
          const { previousLocale } = user
          const { locale, countryChanged, languageChanged } = this.$store.getters
          let localeChange

          if (countryChanged || languageChanged) {
            const fromLocale = i18nData.formatLocale(previousLocale, '_')
            const toLocale = i18nData.formatLocale(locale, '_')
            localeChange = [fromLocale, toLocale].join(', ')
          }

          this.$analytics.track({
            event,
            meta: {
              isCountryChanged: countryChanged,
              isLanguageChanged: languageChanged,
              isLocaleSelectorSelected,
              ...(localeChange && { localeChange })
            }
          })

          this.resetAnalyticsState()
        }
      }
    })
  }
}
